<template>
  <div class="news-tags">
    <div class="common-space common-space-horizontal fx-wrap mb-5" v-if="companies.length">
      <div class="common-space--item mr-10 mb-5" v-for="(item,i) in companies" :key="i">
        <span class="news-tag is-company company-tag is-active">
          <span>{{item.name}}</span>
          <span v-if="data.sensitivity" class="common-positive-negative mr-8" :class="[`is-${data.sensitivity}`]">
            <span>{{sentiment(item.pos)}} {{thePercent}}</span>
          </span>
        </span>
      </div>
    </div>
    <div class="common-space common-space-horizontal fx-wrap">
      <div class="common-space--item mr-8 mb-4" v-for="(item,i) in tagsList" :key="i">
        <span class="news-tag" :class="item.classify">{{item.itemName}}</span>
      </div>
      <!-- <div class="mr-8 mb-4"><span class="news-tag is-event event-tag">获得知识产权</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-industry industry-tag">汽车</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-industry industry-tag">信息技术服务</span></div>

      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-product product-tag">汽车制造</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-product product-tag">换热设备及其零配件</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-product product-tag">其他系统集成服务</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-product product-tag">其他信息科技服务</span></div>

      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-concept concept-tag">节能环保</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-concept concept-tag">无人驾驶</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-concept concept-tag">人工智能</span></div>
      <div class="common-space--item" style="margin-right: 10px; margin-bottom: 5px;"><span class="news-tag is-concept concept-tag">车联网</span></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'newsTags',
  components: {

  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    tagsList() {
      return [
        ...(this.data?.events?.map(e => ({ itemName: e, classify: 'event-tag' })) || []),
        ...(this.data?.industries?.map(e => ({ itemName: e, classify: 'industry-tag' })) || []),
        ...(this.data?.products?.map(e => ({ itemName: e, classify: 'product-tag' })) || []),
        ...(this.data?.concepts?.map(e => ({ itemName: e, classify: 'concept-tag' })) || []),
        ...([...new Set(this.data?.regions)]?.map(e => ({ itemName: e, classify: 'region-tag' })) || [])
      ]
    },
    sentiment(pos) {
      return () => {
        const sensitivity = {
          neutral: '中性',
          positive: '正面',
          negative: '负面',
        }
        return sensitivity[pos || 'neutral']
      }
    },
    thePercent() {
      if (this.data?.confidence !== null) {
        return this.data.confidence + '.00%'
      }
      return '--'
    },
    companies() {
      return this.data?.companies || []
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.news-tags {
  padding: 8px 0;
  .common-space {
    display: flex;
  }
  .news-tag {
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 0.8571428571rem;
    display: flex;
    align-items: center;
  }
}
.news-tags .news-tag.is-company {
  padding: 0;
}
.news-tags .news-tag.is-company > span:first-child {
  border-right: 1px solid #ebeef5;
}
.news-tags .news-tag.is-company > span {
  padding: 2px 4px;
}

// 标签样式
.event-tag {
  border: 1px solid #ae4f2e;
  background-color: #fff;
  color: #ae4f2e;
}
.concept-tag {
  border: 1px solid #da6c4b;
  background-color: #fff;
  color: #da6c4b;
}
.company-tag {
  border: 1px solid #207cff;
  background-color: #fff;
  color: #207cff;
}
.industry-tag {
  border: 1px solid #555fdc;
  background-color: #fff;
  color: #555fdc;
}
.product-tag {
  border: 1px solid #00b8a5;
  background-color: #fff;
  color: #00b8a5;
}
.region-tag {
  border: 1px solid #3e94be;
  background-color: #fff;
  color: #3e94be;
}
</style>
